import Handlebars from 'hbs';

import HomeRepair from './homeRepair';

/* Templates */
import ServiceLocatorModal from '../../templates/components/store-locator-popup/service-locator-modal.html';
import Step01BOX from '../../templates/components/store-locator-partials/step01-boxes-v1.html';
import Step01 from '../../templates/components/store-locator-popup/service-locator-modal_step1-v1.html';
import Step02 from '../../templates/components/store-locator-popup/service-locator-modal_step2-v1.html';

// Data too
//import Locations from '../../copy/uk/storeLocations.json';

import DatePicker from '../vendor/calendar.js';

Handlebars.registerHelper('dayHelper', function (str) {
    var days = {
        0: "Sun",
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat"
    }
    return days[str];
});

Handlebars.registerHelper('timeHelper', function (str) {
    return str.slice(0, 2) + ":" + str.slice(2);
    ;
});

export default class StoreLocatorPopups {

    /* Constructor */
    constructor() {

        const _this = this;

        this.templates = [ServiceLocatorModal, Step01, Step02];
        this.templates_partials = {};

        this.templates_partials.step01Box = Step01BOX;

        this.$slPopup = $('.sl-appointment-start');

        //console.log('StoreLocatorPopups Loaded');

        this.appData = this.data();

        this.steps = 0;

        this.init();

        this.timeslot = "";

        this.dayChosen = "";

        this.formattedTimeChoice = "";

        this.deviceChosen = "";

        this.deviceColor = "";

        this.activeItems = [];

        this.venueId = "";

        this.queueId = "";

        this.productID = 0;

        this.storeID = 0;

        this.imei = "";

    }


    init() {
        const _this = this;

        //_this.openModal();

        _this.gaId=(location.host == 'p6-qa.samsung.com')?"UA-101298876-1":"UA-100137701-12";

        _this.intializeStoreSelection();

    }

    intializeStoreSelection() {

        const _this = this;

        /*//console.log(Locations);
        for (var loc = 0; loc < Locations.length; loc++) {
            if (Locations[loc].place_id == $('.sl-appointment-start').data("location")) {
                _this.storeAddress = Locations[loc].formatted_address;
                _this.storeName = Locations[loc].name;
                _this.dropOffService = Locations[loc].drop_off_service;
            }
        }*/

        _this.storeAddress = $('.sl-appointment-start').data("store_address");
        _this.storeName = $('.sl-appointment-start').data("store_name");
        _this.dropOffService = $('.sl-appointment-start').data("drop_off_service");

        _this.storeID = $('.sl-appointment-start').data("qudini");
        /** Test store need to be replaced **/
         //_this.storeID = 4545;

        _this.storeType = $('.sl-appointment-start').data("store_type");

        //console.log(_this.storeID);
        //console.log(_this.storeType);

        window.state.selectedstoreid = _this.storeID;

        /** Sebn sessionId generated at the time of troubleshooter **/
        _this.tsRef = window.state.tsoutcome.tsSessionRef;


        if (_this.dropOffService == true) {

            _this.steps = 1;

            window.state.islockersavailable = true;

            // render template
            _this.renderTemplate();

        } else {

            _this.serviceType = 'in-store';

            window.state.islockersavailable = false;

            _this.steps = 2;

            // render template
            _this.renderTemplate();

        }

    }

    data() {
        return {
            step01: [
                //IMPORTANT:
                //Mostly dummy data which is repopulated down below in InitEvents()
                {
                    id: '0',
                    name: 'in-store',
                    title: 'One-to-one support',
                    image: '//images.samsung.com/is/image/samsung/p5/uk/support/repair-booking/repair-icons-one-to-one.png?$ORIGIN_PNG$',
                    description: 'One-to-one device support and drop off with a Samsung Expert',
                    productID: 66853
                },
                {
                    id: '1',
                    name: 'drop-off',
                    title: 'Repair Locker',
                    image: '//images.samsung.com/is/image/samsung/p5/uk/support/repair-booking/repair-icons-drop-off-locker.png?$ORIGIN_PNG$',
                    description: 'Drop off your device at an in-store Repair Locker.<br /><br />For same day<sup>3</sup> repair, drop off your device in the Repair Locker by 12pm.<br /><br />Once your device is ready to be collected you will be able to book a slot to pick it up from the Repair Locker.',
                    productID: 67655
                }


            ]

        };
    }

    openModal() {
        const _this = this;

        _this.steps = 0;

        // render template
        _this.renderTemplate();
    }


    renderTemplate() {

        //console.log('renderTemplate LOADED');

        const _this = this;


        if (_this.steps === 1) {

            // Set step01 box template
            this.appData['storeid'] = _this.storeID;
            var source_box = this.templates_partials.step01Box;
            var template_box = Handlebars.compile(source_box);
            var compiled_box = template_box(this.appData);
            // Set step01 template
            var sourceStep = this.templates[this.steps];
            var template_step = Handlebars.compile(sourceStep);
            var compiled_step = template_step({
                data: compiled_box
            });
        }


        if (_this.steps == 2) {
            // Set step02 template
            var sourceStep = this.templates[this.steps];
            var template_step = Handlebars.compile(sourceStep);
            var compiled_step = template_step({
                data: 'TEST'
            });
        }


        //Set modal window
        var source_modal = this.templates[0];
        var template_modal = Handlebars.compile(source_modal);
        var compiled_modal = template_modal({
            data: compiled_step
        });

        //Insert template in DOM
        $(this.$slPopup).html(compiled_modal);

        //Do Polyfill
        _this.polyfil();

        //Init Events
        _this.initEvents();

        //Init Calendar
        if (_this.steps == 2) {
            _this.initCalendar();
        }


    }



    initEvents() {
        const _this = this;


        // ==========================================================================
        // Select Item
        // ==========================================================================

        // ==========================================================================
        // Close modal
        // ==========================================================================

        $('#back-to-map').off('click').on('click', function () { //.step01--box
            $('.sl-selector-start').show(1);
            $('.sl-appointment-start').hide(1);
            // $('.sl-popup').html('');
        });

        $('#back-store-selector').off('click').on('click', function () { //.step01--box
            $('.sl-selector-start').show(1);
            $('.sl-appointment-start').hide(1);
            $('#error-popup').hide();
            // $('.sl-popup').html('');
        });

        // ==========================================================================
        // NEXT button appear
        // ==========================================================================




        // var isActive = false;

        const checkActiveItems = arr => {
            if (arr && arr.length) {
                $('#next-button.sl__modal_form--btn-grey').hide();
                $('#next-button-active.sl__modal_form--btn-blue').show();
                // isActive = true;
            } else {
                $('#next-button.sl__modal_form--btn-grey').show();
                $('#next-button-active.sl__modal_form--btn-blue').hide();
                // isActive = false;
            }
        };

        // ==========================================================================
        // Step 01
        // ==========================================================================

        // Change the title for the store's address

 /*       if (_this.steps == 1) {

            var step01 = [];

            $(".step01--box").show();
            $(".step01--box").css("opacity", 1);

        }*/


        $(".sl__modal--store-name").text(_this.storeName);
        $(".sl__modal--store-location").text(_this.storeAddress);


        function appendWalkInMessage(storeName, storeAddress) {
            // Map store addresses to SES store names
            const storeMappings = {
                "125 Oxford St, Soho, London, W1D 2HS, UK": "SES Oxford Street",
                "Unit 2038 & 2039, First Floor , The Gallery, Westfield stratford city, London E20 1EQ, UK": "SES Stratford"
            };

            // Normalize the storeAddress to avoid whitespace issues (optional)
            const normalizedAddress = storeAddress.trim();

            // Check if the address matches a known SES location
            const mappedStoreName = storeMappings[normalizedAddress] || "";

            // Target SES stores
            const targetStores = ["SES Oxford Street", "SES Stratford"];

            // Check if the mapped name is in our target list
            if (targetStores.includes(mappedStoreName)) {
                // Create the message element
                const message = document.createElement("p");
                message.innerHTML = "Can't find an appointment that works for you? <br> You can now walk-in and speak with one of our experts in-store. Wait times vary.<sup>*</sup>";
                message.style.fontWeight = "100";
                message.style.marginTop = "5px";
                message.style.fontSize = "17px";

                // Find the modal content div
                const modalContent = document.querySelector(".sl__modal--content");

                if (modalContent) {
                    // modalContent.children[1].insertAdjacentElement("beforeend", message);
                    modalContent.children[0].appendChild(message);
                }
            }
        }

        // Usage
        appendWalkInMessage(_this.storeName, _this.storeAddress);




        function getDate(inp) {

            var calDate = inp.replace(/\u200e/g, '');
            var dates = calDate.split(" ");
            const dateObj = new Date(calDate);
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
            return dates[2] + "-" + month + "-" + dates[0];

            /*var dates = inp.split(" ");
            var conv = {
                "Jan": "01",
                "Feb": "02",
                "Mar": "03",
                "Apr": "04",
                "May": "05",
                "Jun": "06",
                "Jul": "07",
                "Aug": "08",
                "Sep": "09",
                "Oct": "10",
                "Nov": "11",
                "Dec": "12",
            };
            return dates[2] + "-" + conv[dates[1]] + "-" + dates[0];*/
        }


        function inverseDate(inp) {
            var dates = inp.split("-");
            var conv = {
                "01": "Jan",
                "02": "Feb",
                "03": "Mar",
                "04": "Apr",
                "05": "May",
                "06": "Jun",
                "07": "Jul",
                "08": "Aug",
                "09": "Sep",
                "10": "Oct",
                "11": "Nov",
                "12": "Dec",
            };


            return dates[2] + " " + conv[dates[1]] + " " + dates[0];
        }

        function populateDays(ajaxData) {


            var days = "";

            //hide the next button which is selected previously



            for (var day = 1; day < ajaxData.length + 1; day++) {

                var daycol = '<div class="sl__modal_calendar-col">';
                    daycol +=       '<div id="day'+day+'" class="sl__modal_calendar--title">'+inverseDate(ajaxData[day - 1].date)+'</div>';
                    daycol +=       '<div class="sl__modal_calendar--timeselection">';
                    daycol +=          '<div class="sl__modal_calendar--timeselection-wrapper">';

                if (ajaxData[day - 1].slots.length > 0) {


                    daycol +=              '<div id="day1container" class="sl__modal_calendar--timeselection-inner">';

                    for (var slot = 0; slot < ajaxData[day - 1].slots.length; slot++) {

                    daycol +=                  '<div class="time" data-dateformatted="'+ajaxData[day - 1].slots[slot].startDate+'" >'+ajaxData[day - 1].slots[slot].startDate.slice(11, 16)+'</div>';

                    }

                    daycol +=              '</div>';
                    daycol +=              '<div class="cont">';
                    daycol +=                  '<div class="arrow"></div>';
                    daycol +=              '</div>';



                } else {

                    daycol +=              '<div id="day1container" class="sl__modal_calendar--timeselection-inner">';
                    daycol +=                  '<div class="no-slots">no-slots</div>';
                    daycol +=              '</div>';
                    daycol +=              '<div class="cont">';
                    daycol +=                  '<div class="arrow"></div>';
                    daycol +=              '</div>';

                }

                    daycol +=          '</div>';
                    daycol +=       '</div>';
                    daycol += '</div>';


                days += daycol;


/*                var dayContainer = document.getElementById("day" + day);

                dayContainer.innerText = inverseDate(ajaxData[day - 1].date);

                var timesContainer = document.getElementById("day" + day + "container");

                while (timesContainer.firstChild) {
                    timesContainer.removeChild(timesContainer.firstChild);
                }

                for (var slot = 0; slot < ajaxData[day - 1].slots.length; slot++) {

                    //clear out all previous elements



                    var slotContainer = document.createElement("div");
                    slotContainer.classList.add("time");
                    $(slotContainer).data("dateFormatted", ajaxData[day - 1].slots[slot].startDate);
                   // $(slotContainer).data("venueId", ajaxData[day - 1].slots[slot].venueId);
                   // $(slotContainer).data("queueId", ajaxData[day - 1].slots[slot].queueId);
                    slotContainer.innerText = ajaxData[day - 1].slots[slot].startDate.slice(11, 16); // + " to " + ajaxData[day-1]["slots"][slot]["end"].slice(11,16);
                    timesContainer.appendChild(slotContainer);

                }

                if (timesContainer.children.length == 0) {
                    var nullMsg = document.createElement("div");
                    nullMsg.innerText = "No slots";
                    // nullMsg.classList.add("null");
                    nullMsg.classList.add("no-slots");
                    timesContainer.appendChild(nullMsg);
                }*/

            }

            //console.log(days);

            $('#slot-list').html(days);

            //_this.scrollTo('.sl-appointment-start .sl__modal--content', 200);






            $('.sl__modal_calendar--timeselection-inner .time').off('click').on('click', function () {
                $('.time').removeClass('slot-selected');
                $(this).toggleClass('slot-selected');
                $('#next-button.sl__modal_form--btn-grey').hide();
                $('#next-button-active.sl__modal_form--btn-blue').show();
                _this.timeslot = this.innerText;
                _this.formattedTimeChoice = $(this).data("dateformatted");
                _this.dayChosen = this.parentElement.parentElement.parentElement.previousElementSibling.innerText;
                //_this.venueId = $(this).data("venueId");
                //_this.queueId = $(this).data("queueId");
            });


           /** $(".sl__modal_calendar--timeselection-inner").slick({
                  vertical: true,
                  verticalSwiping: true,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  infinite: true
            });*/





           // $(".slick-active .sl__modal_calendar--timeselection-inner").each(function() {
            $(".sl__modal_calendar--timeselection-inner").each(function() {

                this.addEventListener("scroll",function(e){
                    //console.log(this, this.offsetHeight + this.scrollTop == this.scrollHeight);
                    if(this.offsetHeight + this.scrollTop == this.scrollHeight){
                        if(this.nextElementSibling.classList.value == "cont"){
                            this.nextElementSibling.style.display = "none";
                        }
                    }
                    else{
                        if(this.nextElementSibling.classList.value == "cont"){
                            this.nextElementSibling.style.display = "";
                        }
                    }
                });

                this.dispatchEvent(new Event("scroll"));

            });

            //$(".slick-active .sl__modal_calendar--timeselection-wrapper .cont").click(function(){
            $(".sl__modal_calendar--timeselection-wrapper .cont").click(function(){
                var currScroll = $(this).prev().scrollTop();
                //console.log(currScroll);
                $(this).prev().animate({ scrollTop: currScroll + 50 + "px" });
            });


           /* $('#slot-list.sl__modal_calendar-row').slick({

                // normal options...
                infinite: false,
                slidesToShow: 8,
                dots: false,
                swipeToSlide: false,
                draggable:true,
                vertical: false,
                verticalSwiping: false,




                responsive: [{

                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: false,
                        swipeToSlide: false
                    }

                }, {

                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: false,
                        swipeToSlide: false
                    }

                }]

            }); */


        }


        /**function isSlotDateChanged() {

            dateRequest();

        }**/






        function dateRequest() {

            /**var today  = new Date();
            today  = today.toLocaleDateString('en-GB', { year: 'numeric',
                            month: 'short',
                            day: '2-digit' }); **/


            var calDate = $('#appointment-date').val();

            _this.storeID = $('.sl-appointment-start').data("qudini");

            _this.storeType = $('.sl-appointment-start').data("store_type");

            window.state.selectedisrservice = _this.serviceType;

            var postData =  {

                "storeId": _this.storeID,
                "storeType": _this.storeType,
                "tsRef": _this.tsRef,
                "serviceType": _this.serviceType,
                "startDate": getDate(calDate)

            }


            var host = window.state.apihost;
            var path = "/uk/repair-booking/";
            var url = host+path+"slots/";

            /**$(".sl__modal_calendar-loading").show();
            $(".sl__modal_calendar-loading").find("img").show();
            $(".sl__modal_calendar-loading").find("p").text("");**/
            let loader =  '<div class="sl__modal_calendar-loading">';
                loader += '    <img src="https://images.samsung.com/is/image/samsung/p5/uk/CSN-StoreLocator/blue_loader_100px.gif?$ORIGIN_GIF$" />';
                loader += '    <p></p>';
                loader += '</div>';
                $('#slot-list').html(loader);
            $('#next-button.sl__modal_form--btn-grey').show();
            $('#next-button-active.sl__modal_form--btn-blue').hide();

            $.post(url, "data=" + encodeURIComponent(JSON.stringify(postData)), "json").done(function (response) {

                if (response.status == "Bad Request") {
                    //$(".sl__modal_calendar-loading").show();
                    //$(".sl__modal_calendar-loading").find("img").hide();
                    //$(".sl__modal_calendar-loading").find("p").text(response.data.statusDescription);
                    //var errorMsg = 'Something went wrong. Please try again with a different date.';
                    showErrorMsg(response.data.statusDescription);
            //    } else if (response.data == null || !('slotsCalendar' in response.data)) {
                } else if (response.status == "unsuccess") {
                    //$(".sl__modal_calendar-loading").show();
                    //$(".sl__modal_calendar-loading").find("img").hide();
                    //$(".sl__modal_calendar-loading").find("p").text("Something went wrong. Please try again with a different date.");
                    var errorMsg = 'Something went wrong. Please try again with a different date.';
                    showErrorMsg(errorMsg);

                } else {
                    var selectedStoreAndSlot = {};
                    selectedStoreAndSlot.storeName = _this.storeName;
                    selectedStoreAndSlot.storeAddress = _this.storeAddress;
                    window.state.selectedStoreAndSlot = selectedStoreAndSlot;
                    //$(".sl__modal_calendar-loading").hide();
                    if (response.data.slotsCalendar.length > 0) {

                        populateDays(response.data.slotsCalendar);

                    } else {
                        var errorMsg = 'There are currently no available appointments at this store. Please try another location.';
                        showErrorMsg(errorMsg);

                    }

                }


            }).done(function (response) {

                console.log('request success');
                $(".sl-subtitle").hide();

            }).fail(function (err) {

                //$(".sl__modal_calendar-loading").show();
                //$(".sl__modal_calendar-loading").find("img").hide();
                //$(".sl__modal_calendar-loading").find("p").text("Something went wrong. Please try again later.");
                var errorMsg = "Something went wrong. Please try again later.";
                showErrorMsg(errorMsg);

            });

        }

        function showErrorMsg (errorMsg) {

            var errMsgHtml =  '<div class="sl__modal_error-msg">';

                errMsgHtml +=     '<p>'+errorMsg+'</p>';

                errMsgHtml += '</div>';

                $('#next-button.sl__modal_form--btn-grey').show();
                $('#next-button-active.sl__modal_form--btn-blue').hide();

                $('#slot-list').html(errMsgHtml);

        }

        // Set selected Appointment Date time on Repair Summary
        function setAppointmentDateTimeOnRS() {
            //{storeName: 'Samsung Experience Store | Norwich', storeAddress: 'St Stephens St, Norwich NR2 1SH, UK', selectedSlot: '2022-12-10T14:30:00.000000+00:00'}

            var storeAndSlot = window.state.selectedStoreAndSlot;
            var dateObj = new Date(storeAndSlot.selectedSlot);

            const options = { day: '2-digit', year: '2-digit', month: 'short'}

            var appointmentTime = dateObj.toLocaleTimeString([], {timeStyle: 'short'});

            var appointmentDate = dateObj.toLocaleDateString([], options);

            var storeName = storeAndSlot.storeName;

            $('#repair_summary').attr("appointment-date", appointmentDate);
            $('#repair_summary').attr("appointment-time", appointmentTime);
            $('#repair_summary').attr("appointment-location", storeName);

            const homeRepair = new HomeRepair();


        }



        function reserveSelectedSlot() {

            //console.log('Reserve Selected Slot');

            var $this = this;

            var host = window.state.apihost;

            var path = "/uk/repair-booking/";

            var form = new FormData();
            form.append('tsRef', _this.tsRef);
            form.append('slotStartDateTime', _this.formattedTimeChoice);

            var selectedStoreAndSlot = window.state.selectedStoreAndSlot;
            selectedStoreAndSlot.selectedSlot = _this.formattedTimeChoice;
            window.state.selectedStoreAndSlot = selectedStoreAndSlot;

            //console.log(window.state.selectedStoreAndSlot);

            var url = host+path+"reservation/";

           //var url = 'http://repair-booking-qudini-server.samsung.com/slots/';
            var settings = {
                url: url,
                data: form,
                processData: false,
                contentType: false,
                dataType: 'json',
                type: "POST"
            }


            $.ajax(settings).done(function (response, _this) {

                //if (response.status == true && ('reservationId' in response.data))  {
                if (response.status == true)  {

                   // console.log('Reservation Success');
                   // console.log(settings.data.slotStartDateTime);
                    // rest the store map to its original
                    $('#back-store-selector').trigger('click');
                    $('#instore-repair-map').hide();
                    $('#repair-request-form').show();
                    $('#repair-request-form .container.form').show();

                    setAppointmentDateTimeOnRS();

                    //_this.scrollTo('#sa-login', 400);

                 } else {

                    console.log('Reservation failed');
                    showErrorMsg("Something went wrong. Please try again with a different date.");

                   /* $(".sl__modal_calendar-loading").show();
                    $(".sl__modal_calendar-loading").find("img").hide();
                    $(".sl__modal_calendar-loading").find("p").text("Something went wrong. Please try again with a different date.");*/

                 }


            }).fail(function (err) {

                console.log(err);

            });



        }

        if (_this.steps == 2) {

            _this.storeID = $('.sl-appointment-start').data("qudini");

            _this.storeType = $('.sl-appointment-start').data("store_type");

            //dateRequest();

          /**  setTimeout(function () { //Change to a proper waiting for value

                dateRequest();

            }, 1000);**/


            $('#appointment-date').on('change', function(){

                setTimeout(function () {

                    dateRequest();

                }, 150);

            });

            /**document.body.addEventListener("mousedown", function (e) {
                if (e.target.classList.contains("qs-square") || e.target.classList.contains("qs-num")) {
                    setTimeout(function () {

                        dateRequest();

                    }, 1000);
                }
            });

            $(".sl__modal_calendar--timeselection-wrapper .cont").click(function(){
                var currScroll = $(this).prev().scrollTop();
                $(this).prev().animate({ scrollTop: currScroll + 50 + "px" });
            });**/

        }



        const appReload = () => {
            location.reload();
        };

        $('.close-modal').off('click').on('click', function () {
            appReload();
            // _this.steps = 0;
            // _this.renderTemplate();
        });

        // ==========================================================================
        // General buttons
        // ==========================================================================
        $('.sl__modal_form--btn.modal--prevstep').off('click').on('click', function () { //.step01--box


            if (_this.serviceType == 'in-store' &&  _this.steps == 2) {

                $('.sl-selector-start').show(1);
                $('.sl-appointment-start').hide(1);

            } else {

                _this.steps--;
                _this.renderTemplate();

            }


        });

        $('.sl__modal_form--btn-blue.modal--nextstep').off('click').on('click', function () { //.step01--box

            if (_this.steps == 2) {

                reserveSelectedSlot();

            } else {
                _this.steps++;
                _this.renderTemplate();
            }
        });

        $('.sl__modal--content .rows__container a').off('click').on('click', function (e) {

            e.preventDefault();
            _this.serviceType = $(this).attr('servicetype');
            _this.steps++;
            _this.renderTemplate();

        });




    }

    initCalendar() {
        // ==========================================================================
        // Calendar
        // ==========================================================================

        var minDateObj = new Date();
        minDateObj.setDate(minDateObj.getDate());
        var maxDateObj = new Date();
        maxDateObj.setDate(maxDateObj.getDate() + 6);



        const picker = DatePicker('.sl__modal_calendar--input', {
            onSelect: (instance, date) => {
                // TODO stuff when a date is selected (or unselected) on the calendar.
            },
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString('en-GB', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit'
                });
                input.value = value; // => '01 Nov 2018'
                $('#appointment-date').trigger('change');
            },
            disableYearOverlay: true
        });

        picker.setMin(minDateObj);
        picker.setMax(maxDateObj);

        // set the current day
        picker.setDate(new Date(), true);

        /**$('.date-icon').on('click', function() {
            $('.sl__modal_calendar--input').focus();
        });**/

    }


    scrollTo(elem, delay) {

        if ($(elem).length) {

            var stepsSummaryHeight = $('.steps-wrapper').outerHeight() + 20;
            stepsSummaryHeight += $('.floating-navigation').hasClass('floating-navigation--fixed') ? 0 : $('.steps-wrapper').outerHeight() ;

            stepsSummaryHeight += ($('.summary-wrapper').is(":visible"))? $('.summary-wrapper').outerHeight():0;


            var scrollTop = $(elem).position().top - stepsSummaryHeight;

            //var scrollTop = $(elem).position().top;
            setTimeout(function() {
                $('html, body').animate({
                        scrollTop: scrollTop
                    }, 500, function () {
                    }
                );
            }, delay);

        }

    }


    //polyfil
    polyfil() {
        if (!Array.prototype.map) {

            Array.prototype.map = function (callback) {

                var T, A, k;

                if (this == null) {
                    throw new TypeError('this is null or not defined');
                }

                var O = Object(this);

                var len = O.length >>> 0;

                if (typeof callback !== 'function') {
                    throw new TypeError(callback + ' is not a function');
                }

                if (arguments.length > 1) {
                    T = arguments[1];
                }

                A = new Array(len);

                k = 0;

                while (k < len) {

                    var kValue, mappedValue;

                    if (k in O) {

                        kValue = O[k];

                        mappedValue = callback.call(T, kValue, k, O);



                        A[k] = mappedValue;
                    }
                    k++;
                }

                return A;
            };
        }
    }


}
